var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { RibbonMessage, RibbonButton } from "./components";
/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the HeaderRegulationRibbonHeaderRegulationRibbonBlock component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
let HeaderRegulationRibbonMessageBlock = class HeaderRegulationRibbonMessageBlock extends React.Component {
    constructor(props) {
        super(props);
        // setup dictionary
        this.dict = this.props.dict;
        // setup cms
        this.cms = this.props.cms;
        this.message = this.cms.Message;
        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider
        };
    }
    componentDidMount() {
        document.body.classList.add("rj-ribbon-is-shown");
    }
    componentWillUnmount() {
        document.body.classList.remove("rj-ribbon-is-shown");
    }
    renderButton() {
        return React.createElement(RibbonButton, { text: this.dict[this.state.dataProvider.chooseBtnText], handler: this.state.dataProvider.changeExpanded, modifier: this.state.dataProvider.chooseModifier });
    }
    /* istanbul ignore next */
    render() {
        const expandedClass = this.state.dataProvider.isExpanded ? "" : "not-expanded";
        const isHiddenClass = this.state.dataProvider.shouldHide && this.message === "" ? "isHidden" : "";
        const message = this.getMessageText();
        return (React.createElement("div", { className: `rj-ribbon__main-container ${isHiddenClass}` },
            React.createElement(RibbonMessage, { className: `rj-ribbon__message ${expandedClass}`, handler: this.state.dataProvider.changeExpanded, message: message, resizeHandler: this.state.dataProvider.winResizeHandler }),
            this.state.dataProvider.hasButton === true && this.renderButton()));
    }
    getMessageText() {
        if (this.message) {
            return this.message;
        }
        else {
            return this.state.dataProvider.message.messageText;
        }
    }
};
HeaderRegulationRibbonMessageBlock = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], HeaderRegulationRibbonMessageBlock);
export { HeaderRegulationRibbonMessageBlock };
//# sourceMappingURL=HeaderRegulationRibbonMessageBlock.js.map